import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PackageIcon, XCircleIcon, TruckIcon } from 'lucide-react';
import { useStore } from '../context/StoreContext';
import { OrderStatus } from '../context/StoreContext';
const statusColors: Record<OrderStatus, string> = {
  Placed: 'bg-blue-100 text-blue-700',
  Confirmed: 'bg-indigo-100 text-indigo-700',
  Shipped: 'bg-orange-100 text-orange-700',
  Delivered: 'bg-green-100 text-green-700',
  Cancelled: 'bg-red-100 text-red-700'
};
export function MyOrdersPage() {
  const navigate = useNavigate();
  const {
    user,
    getUserOrders,
    cancelOrder
  } = useStore();
  if (!user) {
    navigate('/login');
    return null;
  }
  const orders = getUserOrders();
  if (orders.length === 0) {
    return <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center px-4 py-20" data-id="element-1150">
        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} data-id="element-1151">
          <div className="w-24 h-24 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1152">
            <PackageIcon className="w-10 h-10 text-slate-400" data-id="element-1153" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-1154">
            No Orders Yet
          </h2>
          <p className="text-slate-500 mb-8" data-id="element-1155">
            Start shopping to see your orders here.
          </p>
          <Link to="/products" className="inline-flex items-center gap-2 px-8 py-3 bg-sky-600 text-white font-semibold rounded-lg hover:bg-sky-700 transition-colors" data-id="element-1156">
            Start Shopping
          </Link>
        </motion.div>
      </div>;
  }
  return <div className="min-h-screen bg-slate-50" data-id="element-1157">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8" data-id="element-1158">
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6" data-id="element-1159">
          My Orders
        </h1>
        <div className="space-y-4" data-id="element-1160">
          {orders.map((order, index) => <motion.div key={order.id} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-1161">
              <div className="p-4 md:p-6" data-id="element-1162">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4" data-id="element-1163">
                  <div data-id="element-1164">
                    <p className="text-sm font-mono text-slate-500" data-id="element-1165">
                      {order.id}
                    </p>
                    <p className="text-xs text-slate-400 mt-0.5" data-id="element-1166">
                      Placed on{' '}
                      {new Date(order.date).toLocaleDateString('en-IN', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  })}
                    </p>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1167">
                    <span className={`text-xs font-semibold px-3 py-1 rounded-full ${statusColors[order.status]}`} data-id="element-1168">
                      {order.status}
                    </span>
                    <span className="font-bold text-slate-900" data-id="element-1169">
                      ₹{order.totalAmount}
                    </span>
                  </div>
                </div>

                <div className="flex gap-2 overflow-x-auto pb-2" data-id="element-1170">
                  {order.items.map(item => <div key={`${item.product.id}-${item.size}`} className="flex-shrink-0 relative" data-id="element-1171">
                      <img src={item.product.images[0]} alt={item.product.name} className="w-16 h-20 object-cover rounded-lg bg-slate-100" data-id="element-1172" />
                      <span className="absolute bottom-0 right-0 bg-slate-900/80 text-white text-[10px] px-1.5 py-0.5 rounded-tl-lg rounded-br-lg" data-id="element-1173">
                        {item.size}
                      </span>
                    </div>)}
                </div>

                <div className="flex items-center gap-3 mt-4 pt-4 border-t border-slate-100" data-id="element-1174">
                  <Link to={`/order/${order.id}`} className="flex items-center gap-1.5 text-sm font-medium text-sky-600 hover:text-sky-700" data-id="element-1175">
                    <TruckIcon className="w-4 h-4" data-id="element-1176" /> Track Order
                  </Link>
                  {(order.status === 'Placed' || order.status === 'Confirmed') && <button onClick={() => {
                if (confirm('Are you sure you want to cancel this order?')) {
                  cancelOrder(order.id);
                }
              }} className="flex items-center gap-1.5 text-sm font-medium text-red-600 hover:text-red-700 ml-auto" data-id="element-1177">
                      <XCircleIcon className="w-4 h-4" data-id="element-1178" /> Cancel Order
                    </button>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}